const TRACKING_DEBUG_EVENT = "gw:tracking-log";
const STORAGE_KEY = "gw_tracking_debug";

export function isTrackingDebugEnabled() {
	if (!import.meta.client) return false;

	try {
		const params = new URLSearchParams(window.location.search);
		if (params.get("tracking_debug") === "1") {
			sessionStorage.setItem(STORAGE_KEY, "1");
		}
		if (params.get("tracking_debug") === "0") {
			sessionStorage.removeItem(STORAGE_KEY);
			localStorage.removeItem(STORAGE_KEY);
		}
	} catch {}

	if (import.meta.dev) return true;

	try {
		return sessionStorage.getItem(STORAGE_KEY) === "1" || localStorage.getItem(STORAGE_KEY) === "1";
	} catch {
		return false;
	}
}

export function setTrackingDebugEnabled(enabled) {
	if (!import.meta.client) return;

	try {
		if (enabled) {
			sessionStorage.setItem(STORAGE_KEY, "1");
		} else {
			sessionStorage.removeItem(STORAGE_KEY);
			localStorage.removeItem(STORAGE_KEY);
		}
		window.dispatchEvent(new CustomEvent("gw:tracking-debug-toggle", { detail: { enabled } }));
	} catch {}
}

/** @param {{ eventName: string, eventParams?: Record<string, unknown> }} payload */
export function notifyTrackingDebug(payload) {
	if (!import.meta.client || !isTrackingDebugEnabled()) return;

	const detail = {
		eventName: payload.eventName,
		eventParams: payload.eventParams || {},
		timestamp: Date.now(),
	};

	window.dispatchEvent(new CustomEvent(TRACKING_DEBUG_EVENT, { detail }));

	if (import.meta.dev) {
		console.info(
			`%c[Firebase logEvent]%c ${detail.eventName}`,
			"color:#fff;background:#f2af19;padding:2px 6px;border-radius:4px;font-weight:600;",
			"color:#111;font-weight:700;",
			detail.eventParams
		);
	}
}

export function subscribeTrackingDebug(callback) {
	if (!import.meta.client) return () => {};

	const handler = event => callback(event.detail);
	window.addEventListener(TRACKING_DEBUG_EVENT, handler);
	return () => window.removeEventListener(TRACKING_DEBUG_EVENT, handler);
}

export { TRACKING_DEBUG_EVENT };
